import React from 'react';

import InboundEditForm from '@components/shared/inbounds/InboundEdit';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useAdminInboundService } from '@hooks/admin/inbounds/useAdminInboundService';
import { useAdminProductService } from '@hooks/admin/products/useAdminProductService';
import supplierService from '@services/admin/supplierService';

export default function AdminInboundNew() {
  const { warehouses, defaultWarehouseId } = useMerchant();

  return (
    <InboundEditForm
      useInboundService={useAdminInboundService}
      useProductService={useAdminProductService}
      supplierService={supplierService}
      role="admin"
      warehouses={warehouses}
      defaultWarehouseId={defaultWarehouseId}
    />
  );
}
